import { PatientsPage } from "./patients";

export const Patients = PatientsPage;
